angular.module('unica_invitation_room.invitation_room_services')

.factory('InvitationRoomCreateService', function ($http, getBaseApiURL) {

	var invitationRoomCreateService = {};

	invitationRoomCreateService.create = function ( invitationRoomData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-room/create',
			data: invitationRoomData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_room;
			}

		});

	};

	return invitationRoomCreateService;
});

